// Small icon button that flips between light and dark mode. Lives in page
// headers (landing, intake, admin bar) so the choice is reachable everywhere.
import { IconButton, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeMode } from '../ThemeModeProvider.jsx';

const ThemeModeToggle = () => {
  const { mode, toggleMode } = useThemeMode();
  const label = mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <Tooltip title={label}>
      <IconButton onClick={toggleMode} aria-label={label} size="small" color="inherit">
        {mode === 'dark' ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
